import { routes } from '../../../constants/routes';

/**
 * Ruta til den nye kravsiden. Den ligger bevisst i feature-mappa og ikke i
 * src/constants/routes.ts, slik at den kan fjernes i én operasjon senere.
 *
 * Stien er lagt under `steps/qualifications` fordi stegindikatoren i
 * NewApplicationLayout matcher på det prefikset (matchPath med end: false).
 * Da markeres «Kvalifikasjoner» som aktivt steg, akkurat som på den gamle siden.
 */
export const certReqRequirementsRoute = `${routes.application.qualification}/requirements`;

/**
 * Query-parameter som tvinger den gamle kvalifikasjonssiden.
 *
 * Brukes når kravtjenesten svarer 404 på sertifikatkoden: da sender vi brukeren
 * tilbake til den gamle ruta med denne parameteren, slik at hen står på riktig
 * URL (stegindikator og «neste» virker) uten å bli sendt hit igjen.
 */
export const LEGACY_FALLBACK_PARAM = 'legacy';

export const legacyFallbackSearch = `?${LEGACY_FALLBACK_PARAM}=1`;
